// AUTO-GENERATED by /app/scripts/build_recipes_index.cjs — do not edit by hand.
import r0 from "./af.json";
import r1 from "./ar.json";
import r2 from "./bg.json";
import r3 from "./ca.json";
import r4 from "./cs.json";
import r5 from "./cy.json";
import r6 from "./da.json";
import r7 from "./de-AT.json";
import r8 from "./de-CH.json";
import r9 from "./de.json";
import r10 from "./el.json";
import r11 from "./en-AU.json";
import r12 from "./en-GB.json";
import r13 from "./en-NZ.json";
import r14 from "./en.json";
import r15 from "./es.json";
import r16 from "./fi.json";
import r17 from "./fr-CH.json";
import r18 from "./fr.json";
import r19 from "./ga.json";
import r20 from "./gd.json";
import r21 from "./hr.json";
import r22 from "./hu.json";
import r23 from "./is.json";
import r24 from "./it-CH.json";
import r25 from "./it.json";
import r26 from "./ja.json";
import r27 from "./jam.json";
import r28 from "./ka.json";
import r29 from "./ko.json";
import r30 from "./mt.json";
import r31 from "./nl.json";
import r32 from "./no.json";
import r33 from "./pl.json";
import r34 from "./pt-BR.json";
import r35 from "./pt-PT.json";
import r36 from "./ro.json";
import r37 from "./ru.json";
import r38 from "./sk.json";
import r39 from "./sl.json";
import r40 from "./sr.json";
import r41 from "./sv.json";
import r42 from "./sw.json";
import r43 from "./th.json";
import r44 from "./tr.json";
import r45 from "./uk.json";
import r46 from "./xh.json";
import r47 from "./zh-Hant.json";
import r48 from "./zh.json";
import r49 from "./zu.json";

export const recipesByLang = {
  "af": r0,
  "ar": r1,
  "bg": r2,
  "ca": r3,
  "cs": r4,
  "cy": r5,
  "da": r6,
  "de-AT": r7,
  "de-CH": r8,
  "de": r9,
  "el": r10,
  "en-AU": r11,
  "en-GB": r12,
  "en-NZ": r13,
  "en": r14,
  "es": r15,
  "fi": r16,
  "fr-CH": r17,
  "fr": r18,
  "ga": r19,
  "gd": r20,
  "hr": r21,
  "hu": r22,
  "is": r23,
  "it-CH": r24,
  "it": r25,
  "ja": r26,
  "jam": r27,
  "ka": r28,
  "ko": r29,
  "mt": r30,
  "nl": r31,
  "no": r32,
  "pl": r33,
  "pt-BR": r34,
  "pt-PT": r35,
  "ro": r36,
  "ru": r37,
  "sk": r38,
  "sl": r39,
  "sr": r40,
  "sv": r41,
  "sw": r42,
  "th": r43,
  "tr": r44,
  "uk": r45,
  "xh": r46,
  "zh-Hant": r47,
  "zh": r48,
  "zu": r49,
};

export function getRecipes(lang) {
  return recipesByLang[lang] || recipesByLang.en;
}
